/**
 * Mapeia o id do exame para o link de download, sem extensao.
 * O arquivo em si fica em `static/<nome>.pdf` e e copiado sem hash para a raiz
 * do site, entao a URL e permanente e nao muda quando o PDF e atualizado.
 * A URL sem extensao e resolvida pelos blocos `location` em
 * `devops/default.conf`, que servem o .pdf e definem o Content-Disposition
 * (sem ele o navegador sugere o nome pelos metadados internos do PDF).
 */
const EXAM_DOWNLOAD_FILES = {
  42992: 'niptampliado',
  7806: 'niptampliado',
}

const getDocForDownload = idExam => {
  const isExamWithDownload = String(process.env.GATSBY_EXAM_WITH_OPTION_DOWNLOAD)
    .split(',')
    .some(item => item === String(idExam))

  if (!isExamWithDownload) return ''

  const fileName = EXAM_DOWNLOAD_FILES[idExam]

  return fileName ? `/${fileName}` : ''
}

module.exports = getDocForDownload
module.exports.EXAM_DOWNLOAD_FILES = EXAM_DOWNLOAD_FILES
